var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21534_11691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6754 31.5469L17 31.824L17.3247 31.5469C21.1195 28.3074 23.9886 25.2712 25.912 22.4356C27.8344 19.6015 28.8334 16.9364 28.8334 14.45C28.8334 7.10354 23.2106 2.33331 17 2.33331C10.7894 2.33331 5.16669 7.10354 5.16669 14.45C5.16669 16.9364 6.16563 19.6015 8.08801 22.4356C10.0115 25.2712 12.8805 28.3074 16.6754 31.5469Z",
    fill: "#FFF0D6",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3636 19.8978V9.46594H13.5227V10.625H14.6818V9.46594H19.3182V10.625H20.4773V9.46594H21.6364V19.8978H20.4773V18.7387H19.3182V19.8978H14.6818V18.7387H13.5227V19.8978H12.3636ZM13.5227 17.5796H14.6818V16.4205H13.5227V17.5796ZM13.5227 15.2614H14.6818V14.1023H13.5227V15.2614ZM13.5227 12.9432H14.6818V11.7841H13.5227V12.9432ZM19.3182 17.5796H20.4773V16.4205H19.3182V17.5796ZM19.3182 15.2614H20.4773V14.1023H19.3182V15.2614ZM19.3182 12.9432H20.4773V11.7841H19.3182V12.9432ZM15.8409 18.7387H18.1591V10.625H15.8409V18.7387Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21534_11691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.879c914b9836f4d2b4ade235ecc66bef.svg";
export { ForwardRef as ReactComponent };